import React, { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import PageContainer from "./layout/PageContainer.js";
import JsonLd from "./JsonLd.js";
import GuideCoverHero from "./guide/GuideCoverHero.js";
import GuideTableOfContents from "./guide/GuideTableOfContents.js";
import { EMOTIONAL_AWARENESS_GUIDE } from "../constants/emotionalAwarenessGuide.js";
import { EMOTIONAL_AWARENESS_COVER } from "../constants/emotionalAwarenessGuideVisuals.js";
import { buildGuideJsonLd } from "../utils/guideJsonLd.js";
import "../mental-clarity-guide.css";

const DEFAULT_TITLE = "Ahavibes — Stop reacting. Start thinking clearly.";
const DEFAULT_DESCRIPTION =
  "A guided framework to examine interpretations, reduce mental noise, and make better decisions.";
const PAGE_TITLE = "Emotional Awareness: A Practical Guide | Ahavibes";

const EmotionalAwareness = () => {
  const jsonLd = useMemo(() => buildGuideJsonLd(EMOTIONAL_AWARENESS_GUIDE), []);

  useEffect(() => {
    document.title = PAGE_TITLE;

    let meta = document.querySelector('meta[name="description"]');
    const createdMeta = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const previousDescription = meta.getAttribute("content");
    meta.setAttribute("content", EMOTIONAL_AWARENESS_GUIDE.description);

    return () => {
      document.title = DEFAULT_TITLE;
      if (createdMeta) {
        meta.remove();
      } else {
        meta.setAttribute("content", previousDescription || DEFAULT_DESCRIPTION);
      }
    };
  }, []);

  return (
    <>
      <JsonLd data={jsonLd} id="emotional-awareness-jsonld" />
      <PageContainer size="wide" className="mental-clarity-guide">
        <GuideCoverHero
          headline={EMOTIONAL_AWARENESS_GUIDE.headline}
          lead={EMOTIONAL_AWARENESS_GUIDE.description}
          cover={EMOTIONAL_AWARENESS_COVER}
        />
        <GuideTableOfContents
          sections={EMOTIONAL_AWARENESS_GUIDE.sections}
          basePath="/emotional-awareness"
        />
        <nav className="guide-section-nav" aria-label="Pillar navigation">
          <div className="guide-section-nav__links">
            <Link
              to="/structured-thinking"
              className="guide-section-nav__link guide-section-nav__link--prev"
            >
              &larr; Previous: Structured Thinking
            </Link>
            <Link
              to="/better-decisions"
              className="guide-section-nav__link guide-section-nav__link--next"
            >
              Next: Better Decisions &rarr;
            </Link>
          </div>
        </nav>
      </PageContainer>
    </>
  );
};

export default EmotionalAwareness;
